import { Device, until } from '@helpers/media';
import useMedia from '@hooks/useMedia';
import BranchCard from '@stories/Components/Cards/BranchCard/BranchCard';
import * as React from 'react';
import S from './BranchCards.styles';
const BranchCards = (props) => {
    const paddingOffset = useMedia([until(Device.TabletLarge)], [60], 0);
    const rowMax = useMedia([until(Device.TabletSmall), until(Device.TabletLarge), until(Device.DesktopSmall)], [1, 2, 3], 4);
    return (React.createElement(S.Container, null,
        React.createElement(S.Grid, { mobileCarousel: props.items.length > 1, paddingOffset: paddingOffset, "data-row-max": rowMax, translations: props.translations }, props.items.map((item) => (React.createElement(BranchCard, { key: item.id, ...item }))))));
};
export default BranchCards;
